import React from 'react'
import { isObservable, observe } from 'mobx'
import { useConstrainable } from '@morningtrain/react-filters'

export default function useOnConstraintChange (callback) {
  const constrainable = useConstrainable()

  React.useEffect(() => {
    let disposer = null

    if (isObservable(constrainable.constraints)) {
      disposer = observe(constrainable.constraints, change => {
        callback(change)
      })
    }

    return () => {
      if (typeof disposer === 'function') {
        disposer()
      }
    }
  })

  return null
}
